import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {DataService} from '../data.service';
import {HhgBookShipAccessorials} from 'src/app/features/hhg-shipment-accessorials/hhg-shipment-accessorial';


@Injectable({
  providedIn: 'root'
})
export class HhgBookShipAccessorialsService extends DataService {

  private baseURI = this.apiUri + '/hhgaccessorialinfo/';
  private shipInfoURI = this.apiUri + '/shipmentsinfo/';
  private hhgAccRatesURI = this.apiUri + '/ratesquerydetails/';

  constructor(http: HttpClient) {
    super(http);
  }

  getAccessorialsByShipmentId(shipmentsId: any): Observable<any> {
    this.setUri(this.baseURI + shipmentsId + '/shipmentsId');
    if (shipmentsId !== undefined) {
      return this.get();
    }

  }

  updateAccessorialsByShipmentId(shipmentsId: any): Observable<any> {
    this.setUri(this.baseURI + 'deleteAccessorials');
    return this.get();
  }

  saveOrUpdateHhgAccessorials(hhgBookShipAccessorialsArray: HhgBookShipAccessorials[]): Observable<any> {
    this.setUri(this.baseURI + 'updateAccessorials');
    return this.update(hhgBookShipAccessorialsArray);
  }

  deleteBybookAccessorialsId(bookAccessorialId: any): Observable<any> {
    this.setUri(this.baseURI + 'deleteAccessorials');
    return this.update(bookAccessorialId);
  }

  getShipmentInfoByBookShipmentId(bookshipmentid: number): Observable<any> {
    return this.http.get(this.shipInfoURI + bookshipmentid + '/bookshipmentid');
  }

  /**
   * @description fetches the calculated HHG results.
   */
  getHhgCalculatedResults(payload): Observable<any> {
    return this.http.post(this.hhgAccRatesURI + 'fetchShipmentDetails/', payload);
  }
}
